import {
  ChevronRightIcon,
  QuestionMarkCircleIcon,
} from '@heroicons/react/20/solid'
import FormatNumericValue from '@components/shared/FormatNumericValue'
import SheenLoader from '@components/loading/SheenLoader'
import ImageWithFallback from '@components/image/ImageWithFallback'
import { useWalletTokensWithPrice } from 'hooks/useWalletTokensWithPrice'
import { TokenMetadataItem } from 'types/token'

const WalletBalances = ({
  onClick,
  isDisabled,
}: {
  onClick: (mint: string, token?: TokenMetadataItem) => void
  isDisabled?: (token: TokenMetadataItem) => boolean
}) => {
  const { tokens, loading } = useWalletTokensWithPrice()

  return (
    <div>
      {tokens?.length ? (
        tokens.map((token) => {
          const {
            mint,
            decimals,
            name,
            symbol,
            image_url,
            price,
            uiAmount,
            value,
            latest_price_usd,
            volume_24h_usd,
            amount_24h,
            trades_count_24h,
            token_program,
            description,
            twitter,
            telegram,
            coingecko_id,
            website,
          } = token

          const tokenDetails = {
            mint,
            decimals,
            name,
            symbol,
            image_url,
            latest_price_usd,
            volume_24h_usd,
            amount_24h,
            trades_count_24h,
            token_program,
            description,
            twitter,
            telegram,
            coingecko_id,
            website,
          }

          const disabled = isDisabled ? isDisabled(tokenDetails) : false

          return (
            <div className="-mx-3" key={mint}>
              <button
                className={`flex w-full items-center justify-between rounded-xl p-3 focus:outline-none ${
                  disabled
                    ? 'cursor-not-allowed opacity-50'
                    : 'md:hover:bg-th-bkg-3'
                }`}
                onClick={() => !disabled && onClick(mint, tokenDetails)}
                disabled={disabled}
              >
                <div className="flex items-center">
                  {image_url ? (
                    <ImageWithFallback
                      className="mr-2.5"
                      height={32}
                      width={32}
                      src={image_url}
                      alt={`${symbol} token logo`}
                    />
                  ) : (
                    <QuestionMarkCircleIcon className="mr-2.5 size-8 text-th-fgd-4" />
                  )}
                  <div className="text-left">
                    <p className="mb-1.5 leading-none text-th-fgd-1">
                      {symbol}
                    </p>
                    <p className="text-sm leading-none">
                      {price ? <FormatNumericValue value={price} isUsd /> : '–'}
                    </p>
                  </div>
                </div>
                <div className="flex items-center space-x-2">
                  <div className="flex flex-col items-end">
                    <p className="mb-1.5 leading-none text-th-fgd-1">
                      <FormatNumericValue
                        value={uiAmount}
                        decimals={decimals}
                      />
                    </p>
                    <p className="text-sm leading-none">
                      {price ? <FormatNumericValue value={value} isUsd /> : '–'}
                    </p>
                  </div>
                  <ChevronRightIcon className="size-5 text-th-fgd-3" />
                </div>
              </button>
            </div>
          )
        })
      ) : loading ? (
        Array.from({ length: 6 }, (_, i) => (
          <SheenLoader className="flex flex-1 rounded-none" key={i}>
            <div
              className={`h-12 w-full ${i % 2 ? 'bg-th-bkg-2' : 'bg-th-bkg-3'}`}
            />
          </SheenLoader>
        ))
      ) : (
        <div className="flex items-center justify-center rounded-xl border border-th-bkg-4 p-6">
          <p className="text-center">No tokens found...</p>
        </div>
      )}
    </div>
  )
}

export default WalletBalances
